import { RefObject, useContext, useEffect, useRef, useState } from "react";
import { IoIosSend, IoIosChatbubbles, IoMdArrowForward } from "react-icons/io";
import { IoCloseCircle } from "react-icons/io5";
import VideoContext from "../../store/video-context";
import ChatBox from '../ChatBox/ChatBox';
import { toast } from 'react-toastify';
import { useMediaQuery } from 'react-responsive';


const Conversations = (props: any) => {
  const vContext = useContext(VideoContext);
  const [chats, setChats] = useState([]);
  const isAdmin = props.isAdmin;

  const chatMsgInputRef = useRef() as RefObject<HTMLInputElement>;
  const chatBodyRef = useRef() as RefObject<HTMLInputElement>;

  const [chatType, setChatType] = useState(true);
  const [openConversation, setOpenConversation] = useState(props.chatSection);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const [isSend, setIsSend] = useState(false);
  // const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    loadChat()
    if(props.chats.txData[0].transmission_status == 1 )
    {
   setInterval(()=> 
    loadChat(),
      10000)
    }
    
  }, []);
  useEffect(() => {
    // loadChat()
    if (!chatType) {
      setChatType(!chatType);
    }
  }, [isAdmin]);
  useEffect(() => {
    // console.log('chatupdated', chats);
    (chats.filter((c:any) => c.isSelected === true && c.user_id !== vContext.userData.user_id).length
     === chats.filter((c:any) => c.user_id !== vContext.userData.user_id).length) ? setIsSelectedAll(true) : setIsSelectedAll(false);
     if(isSend){
       chatBodyRef.current!.scrollTop = chatBodyRef.current!.scrollHeight;
       setIsSend(false)
    }
  }, [chats]);

  const dateMDT=(time:any)=>{
    let chatTime = new Date(time);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${monthNames[chatTime.getMonth()]}, ${chatTime.getDate()} ${chatTime.getHours()}:${chatTime.getMinutes()}`;
    // return chatTime1;
  }

  const updateChatType = () => {
    setChatType(!chatType);
  }
  const closeReplyMsgContainer = ()=>{
    vContext.setIsReplyHandler(false);
  }
  const handlerSendMsg = () => {
    let mode = 'public';
    let msg = chatMsgInputRef.current!.value
    if (msg.trim().length > 0) { // need help here
      // normal chat chatid blank , for reply to its required
      let time;
      chatMsgInputRef.current!.value = "";
      if (vContext.isYoutube) {
        // console.log('Conversations time', props.getYTCurrentTime())
        time = parseInt(props.getYTCurrentTime())
      } else {
        time = vContext.currentVideoTime;
      }
      let replyTo = vContext.isReply ? vContext.replyMsg.id: '';
      // console.log("send");
      let data:{ [index: string]: any } = { command:'saveChat'};
      data.transID=vContext.transId;
      data.userID = vContext.userId;
      data.chat = msg;
      data.time = time;
      data.mode = mode;
      data.replyTo = replyTo;
      //fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=saveChat&transID=" + vContext.transId + "&userID=" + vContext.userId + "&chat=" + msg + "&time=" + time + "&mode=" + mode + "&replyTo=" + replyTo)
      fetch('https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php', {
       method: 'POST',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(data) //JSON.stringify({a: 1, b: 'Textual content'})
     })  
      .then(res => res.json())
        .then((sentMsgData) => {
          // console.log('save chat msg', sentMsgData)
          if (sentMsgData.status === "success") {
            loadChat()
            setIsSend(true);
            if(vContext.isReply){
              vContext.setIsReplyHandler(false);
            }
            // chatBodyRef.current!.scrollTop = chatBodyRef.current!.scrollHeight;
          } else {
            // console.log("Fail save chat msg")
            chatMsgInputRef.current!.value = msg;
          }
        })
        .catch((error) => {
          chatMsgInputRef.current!.value = msg;
          console.error('Error:(handlerSendMsg)', error)
        })
    }
  }

  const onEnterSendMsg = (e: any) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      handlerSendMsg();
    }
  }
  const loadChat = () => {
    fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=getChat&transID=" + vContext.transId)
      .then(res => res.json())
      .then((chatData) => {
        // console.log('chatData', chatData);
        if (chatData.status === 'success') {

          chatData.data.map((item: any) => item['isSelected'] = false);
          setChats(chatData.data);
          // chatBodyRef.current!.scrollTop = chatBodyRef.current!.scrollHeight;
        } else {
          // console.log('Fail chat load')
        }
      })
      .catch((error) => {
        console.error('Error:(conversation Use effect)', error);
      })
  }

  const chatScrollHandler = () => {
    document.body.click()
  }

  const chatSelectedHandler = (item: any) => {
    setChats((existing: any) => existing.map((c: any) => c.id === item.id ? { ...c, isSelected: !item.isSelected } : c));
  }

  const selectAllHandler = () => {
    setChats((existing: any) => existing.map((c: any) => c.user_id !== vContext.userData.user_id ? { ...c, isSelected: !isSelectedAll } : c));
  }
  const handlerReplyChatMsg = ()=>{
    vContext.setIsReplyHandler(false);
  }

  const seekVideoAndToggleChat = (time:any) =>{
    //alert("seek chat");
    //if(vContext.videoData.txData[0].youtube_flag === 0){
      props.seekVideo(time);
      props.toggleChat();
   // }
  }

  const deleteChatHandler = () => {
    // console.log("deleteHandler", chats);
    let deletedIds = chats.filter((f: any) => f.isSelected === true).map((d: any) => d.id);
    let data = { command: 'deleteChat', transID: vContext.transId, chatID: deletedIds };
    fetch('https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data) //JSON.stringify({a: 1, b: 'Textual content'})
    })
      .then(res => res.json())
      .then((deleteChatMsgData) => {
        // console.log('deleteChatMsgData',deleteChatMsgData);
        if (deleteChatMsgData.status === "success") {
          loadChat();
          toast.dark("Chat Deleted Successfully!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          // console.log("Fail delete chat msg");
          toast.dark("Delete Failed!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        console.error('Error:(deleteChatHandler)', error);
      })
    // console.log('ids', deletedIds);
  } 
   const isLandscape = useMediaQuery({ query: '(orientation: landscape)' })


  return (
    <div id="conversation" className={`card blue-shadow-box conversation-section${(openConversation) ? ' open-conversation' : ''}`}>
    
            {vContext.isVideoFullscreen ?  <>
        {isLandscape ? "" : 
                  <div className="conversation-close d-lg-none" onClick={props.toggleChat}><IoCloseCircle size={36} /></div>
                }
       </> 
       :
       <div className="conversation-close d-lg-none" onClick={props.toggleChat}><IoCloseCircle size={36} /></div>

      }
      <div className="card-header">
        {/* <div className="video-conversation-close" onClick={()=>{setOpenConversation(!openConversation)}}> */}
        <div className="video-conversation-close" onClick={() => { props.toggleChat() }}>
       {
         (openConversation) ?
           <IoMdArrowForward size={40} /> :
           <IoIosChatbubbles size={40} />
       }
     </div>

        <div className="card-header-text">Conversations</div>
        {(isAdmin) ?
          <div className="chat-type-container d-flex">
            <div>Private</div>
            <label className="switch">
              <input type="checkbox" checked={chatType} onChange={updateChatType} />
              <span className="slider round"></span>
            </label>
            <div>Public</div>
          </div>
          : <></>}
      </div>
      {(!chatType) &&
        <div className="all-checkbox">
          <div className="select-all">
            <input type="checkbox" id="chats-select-all" checked={isSelectedAll} onChange={() => { selectAllHandler() }} /><label htmlFor="chats-select-all" className="mb-0 pl-2">Select All</label>
          </div>
          <div className="delete-selected" onClick={() => { deleteChatHandler() }}>{isSelectedAll ? 'Delete All' : 'Delete'}</div>
        </div>
      }
      <div className={"card-body" + (!chatType ? ' private-chats' : '')} ref={chatBodyRef} onScroll={chatScrollHandler}>
        <div className="chat-container-list">
          {(chats) ?
            <>
              {
                chats.map((item: any) => {
                  return (
                    <ChatBox seekVideo={seekVideoAndToggleChat} chatsData={item} key={item.id} privateChat={true} loadchat={loadChat} replyItem={item.replyTo == '0'? undefined : chats.find((c:any)=> c.id === item.replyTo)} />
                  )
                })
              }
            </> : <></>
          }
          {(chats && isAdmin) ?
            <>
              {
                chats.filter((chat: any) => chat.user_id !== vContext.userData.user_id).map((item: any) => {
                  return (
                    <ChatBox seekVideo={seekVideoAndToggleChat} chatsData={item} key={item.id} chatSelected={chatSelectedHandler} privateChat={false} loadchat={loadChat} />
                  )
                })
              }
            </> : <></>
          }
          {vContext.isReply &&
          <div className="chat-container edit-reply-chat public-chat-container" onClick={()=>closeReplyMsgContainer()}>
            <div className="d-flex align-items-start minw-100">
              <div className="chat-img lg-tooltip-trigger">
                <img src={vContext.replyMsg.user_photo !== ''? window.location.origin + "/style/images/commonspeciality/dr_photos/" + vContext.replyMsg.user_photo : "https://statinfer.com/wp-content/uploads/dummy-user.png"} 
                alt={vContext.replyMsg.user_name} className="user-img" />
              </div>
              <div className="chat-text">
                <div className="chat-reply">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="chat-reply-username pr-2"> {vContext.replyMsg.user_name}</div>
                      <div className="chat-reply-time">{dateMDT(vContext.replyMsg.chat_time)}</div>
                    </div>
                  </div>
                  <div className="chat-reply-msg">{vContext.replyMsg.chat_text}</div>
                </div>
              </div>
              <div className="admin-chat-img">
                <img src="https://statinfer.com/wp-content/uploads/dummy-user.png" alt=" Support Team" className="user-img" />
              </div>
              <div className="reply-close" onClick={()=>handlerReplyChatMsg}>&times;</div>
            </div>
          </div>
           }
        </div>
      </div>
      <div className="card-type-box">
        <input type="text" placeholder="Type your questions here" className="chat-input" ref={chatMsgInputRef} onKeyUp={(e: any) => { onEnterSendMsg(e) }} />
        <div className="send-btn" >
          <IoIosSend color="#fff" size={22} onClick={() => { handlerSendMsg() }} />
        </div>
      </div>
    </div>
  )
};

export default Conversations;
